import { MapPin, Globe, CalendarDays, Info, Flag, Newspaper, ScrollText } from "lucide-react";
import { renderBody } from "../../pages/InfoPage";

const isEmbed = (u) => /google\.[a-z.]+\/maps\/(d\/)?embed|openstreetmap\.org\/export\/embed|maps\.google\.com\/maps\?.*output=embed/.test(u || "");

export default function RallyInfo({ rally, stages = [] }) {
  const empty = !rally.program && !rally.logistics && !rally.map_url && !rally.website && !stages.length;
  if (empty) return <div className="rl-card p-8 text-center text-slate-500" data-testid="rally-info-empty">L'organizzatore non ha ancora pubblicato programma e informazioni per questo rally.</div>;
  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="rally-info">
      <div className="space-y-6">
      {rally.program && (
        <div className="rl-card p-6" data-testid="rally-info-program-view">
          <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-4"><CalendarDays className="w-5 h-5 text-[#FF9F0A]" /> Programma</h2>
          <div className="space-y-3 text-sm">{renderBody(rally.program)}</div>
        </div>
      )}
      {stages.length > 0 && (
        <div className="rl-card p-6" data-testid="rally-info-stages">
          <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-4"><Flag className="w-5 h-5 text-[#FF1E27]" /> Prove speciali</h2>
          <div className="divide-y divide-white/5 text-sm">{stages.map(s => <div key={s.id} className="flex justify-between py-2"><span>{s.name}</span><span className="font-mono-rl text-slate-400">{s.km ? `${s.km} km` : ""}</span></div>)}</div>
        </div>
      )}
      {rally.news?.length > 0 && (
        <div className="rl-card p-6" data-testid="rally-info-news">
          <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-4"><Newspaper className="w-5 h-5 text-[#FF9F0A]" /> News dell'organizzatore</h2>
          {rally.news.map((n, i) => <div key={i} className="mb-3"><div className="font-semibold text-sm">{n.title}</div><div className="text-sm text-slate-400">{n.body}</div></div>)}
        </div>
      )}
      </div>
      <div className="space-y-6">
        {rally.map_url && (
          <div className="rl-card p-6" data-testid="rally-info-map-view">
            <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-4"><MapPin className="w-5 h-5 text-[#FF1E27]" /> Mappa</h2>
            {isEmbed(rally.map_url)
              ? <iframe title="mappa" src={rally.map_url} className="w-full h-72 rounded-lg border-0" loading="lazy" allowFullScreen />
              : <a href={rally.map_url} target="_blank" rel="noreferrer" className="btn-outline-rl !py-2 !px-4 text-xs inline-block">APRI LA MAPPA</a>}
          </div>
        )}
        {rally.logistics && (
          <div className="rl-card p-6" data-testid="rally-info-logistics-view">
            <h2 className="font-display font-bold text-xl flex items-center gap-2 mb-4"><Info className="w-5 h-5 text-[#30D158]" /> Info logistiche</h2>
            <div className="space-y-3 text-sm">{renderBody(rally.logistics)}</div>
          </div>
        )}
        {rally.rules_note && <div className="rl-card p-6 text-sm text-slate-400" data-testid="rally-info-rules"><h2 className="font-display font-bold text-xl flex items-center gap-2 mb-2 text-white"><ScrollText className="w-5 h-5 text-slate-300" /> Regolamento</h2>{rally.rules_note}</div>}
        {rally.website && <a href={rally.website} target="_blank" rel="noreferrer" className="btn-outline-rl !py-2 !px-4 text-xs inline-flex items-center gap-2" data-testid="rally-info-website-link"><Globe className="w-4 h-4" /> SITO UFFICIALE</a>}
      </div>
    </div>
  );
}
